<template>
    <div class="basic-dialog contract-sign-dialog">
        <el-dialog
            title="签订合同"
            :visible="visible"
            @update:visible="handleUpdateVisible"
            width="720px"
            :close-on-click-modal="false"
            :destroy-on-close="true"
        >
            <el-scrollbar class="dialog-scrollbar">
                <ActionForm
                    ref="actionFormRef"
                    :desc="{
                        label: '合同说明',
                        placeholder: '请填写你匹配该任务的能力、优势等，也可提交附件证明',
                    }"
                >
                    <!-- <template slot="custom" slot-scope="scope"> </template> -->
                </ActionForm>
            </el-scrollbar>

            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="handleUpdateVisible(false)">取 消</el-button>
                <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import ActionForm from "./ActionForm.vue";

export default {
    data() {
        return {};
    },

    props: {
        visible: {
            type: Boolean,
            required: true,
        },
    },

    components: {
        ActionForm,
    },

    methods: {
        reset() {
            this.$refs.actionFormRef?.reset?.();
        },

        handleUpdateVisible(val) {
            this.$emit("update:visible", val);

            if (!val) {
                this.reset();
            }
        },

        handleConfirm() {
            this.$refs.actionFormRef?.validate((valid, data) => {
                if (valid) {
                    this.$emit("confirm", {
                        description: data.description,
                        urls: data.urls.map((item) => ({ name: item.name, url: item.url })),
                        files: [...data.files],
                    });
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.contract-sign-dialog {
    ::v-deep .el-dialog {
        padding-inline: 30px;
    }

    ::v-deep .el-dialog__header {
        border-bottom: 1px solid #e6e7eb;
        padding: 16px 0 12px 0;
        display: flex;
        justify-content: space-between;

        .el-dialog__title {
            font-weight: 500;
            font-size: 14px;
            color: #303133;
        }

        .el-dialog__headerbtn {
            position: relative;
            left: 0;
            top: 0;
            font-size: 16px;
        }
    }

    ::v-deep .el-dialog__body {
        padding: 0;
    }

    ::v-deep .el-dialog__footer {
        padding: 0 0px 40px;

        .el-button {
            min-width: 78px;
            height: 32px;

            &.el-button--primary {
                background: linear-gradient(270deg, #594fed 0%, #291ce7 100%);
                border-color: #291ce7;
            }
        }
    }

    .dialog-scrollbar {
        ::v-deep .el-scrollbar__wrap {
            max-height: 600px;
            margin: 0 !important;
            padding: 30px 36px 40px 18px;

            &::-webkit-scrollbar {
                display: none;
            }
        }
    }
}
</style>
